module.exports = __webpack_public_path__ + "img/person.3d3cd545.svg";